// Subscribes a component to the localStorage-backed item MIRROR (real API data
// bridged for the entry/quote modals — never mock data; seeding was removed
// for release). Returns a version counter that bumps on every write so screens
// re-read the mirror and re-render.

import { subscribe } from 'pages/inquiry-processor/utils/storage';
import { useEffect, useState } from 'react';

export function useInquiryStore(): number {
  const [version, setVersion] = useState(0);

  useEffect(() => {
    const bump = () => setVersion((v) => v + 1);
    const unsub = subscribe(bump);
    // Cross-tab sync: a product created on the Master Products page (opened in a
    // new tab) writes localStorage, which fires `storage` here so the inquiry
    // picker refreshes without a manual reload.
    window.addEventListener('storage', bump);
    return () => {
      unsub();
      window.removeEventListener('storage', bump);
    };
  }, []);

  return version;
}
